// extracted by mini-css-extract-plugin
module.exports = {"SectionHeading":"SectionHeading_SectionHeading__28ApS","SectionHeadingTitle":"SectionHeading_SectionHeadingTitle__1d6oP"};